var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "loader": _vm.loading
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.left",
      value: (3),
      expression: "3",
      modifiers: {
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.right",
      value: (3),
      expression: "3",
      modifiers: {
        "right": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "headline"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.profile.activityType == 1 ? _vm.profile.orgName : _vm.profile.contactFio) + "\n        ")])], 1), _vm._v(" "), _c('v-separator'), _vm._v(" "), _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('v-row', {
    directives: [{
      name: "margin",
      rawName: "v-margin.xs.top",
      value: (3),
      expression: "3",
      modifiers: {
        "xs": true,
        "top": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.sm.top",
      value: (0),
      expression: "0",
      modifiers: {
        "sm": true,
        "top": true
      }
    }]
  }, [_c('v-col', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("Реквизиты")])], 1)], 1), _vm._v(" "), _vm._l((_vm.org), function(item, index) {
    return _c('v-row', {
      key: index
    }, [_c('v-col', {
      attrs: {
        "xs": "3",
        "sm": "6"
      }
    }, [_c('v-text', {
      attrs: {
        "danger": item[2]
      }
    }, [_vm._v("\n                            " + _vm._s(item[0]) + "\n                        ")])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "xs": "9",
        "sm": "6"
      }
    }, [_c('v-text', [_vm._v(_vm._s(item[1]))])], 1)], 1)
  })], 2), _vm._v(" "), (_vm.profile.activityType == 1) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('v-row', {
    directives: [{
      name: "margin",
      rawName: "v-margin.xs.top",
      value: (3),
      expression: "3",
      modifiers: {
        "xs": true,
        "top": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.sm.top",
      value: (0),
      expression: "0",
      modifiers: {
        "sm": true,
        "top": true
      }
    }]
  }, [_c('v-col', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("Руководитель")])], 1)], 1), _vm._v(" "), _vm._l((_vm.director), function(item, index) {
    return _c('v-row', {
      key: index
    }, [_c('v-col', {
      attrs: {
        "xs": "3",
        "sm": "6"
      }
    }, [_c('v-text', {
      attrs: {
        "danger": item[2]
      }
    }, [_vm._v("\n                            " + _vm._s(item[0]) + "\n                        ")])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "xs": "9",
        "sm": "6"
      }
    }, [_c('v-text', [_vm._v(_vm._s(item[1]))])], 1)], 1)
  })], 2) : _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('v-row', {
    directives: [{
      name: "margin",
      rawName: "v-margin.xs.top",
      value: (3),
      expression: "3",
      modifiers: {
        "xs": true,
        "top": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.sm.top",
      value: (0),
      expression: "0",
      modifiers: {
        "sm": true,
        "top": true
      }
    }]
  }, [_c('v-col', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("Личные данные")])], 1)], 1), _vm._v(" "), _vm._l((_vm.contact), function(item, index) {
    return _c('v-row', {
      key: index
    }, [_c('v-col', {
      attrs: {
        "xs": "3",
        "sm": "6"
      }
    }, [_c('v-text', {
      attrs: {
        "danger": item[2]
      }
    }, [_vm._v("\n                            " + _vm._s(item[0]) + "\n                        ")])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "xs": "9",
        "sm": "6"
      }
    }, [_c('v-text', [_vm._v(_vm._s(item[1]))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-row', [(_vm.profile.activityType == 1) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('v-row', {
    directives: [{
      name: "margin",
      rawName: "v-margin.xs.top",
      value: (3),
      expression: "3",
      modifiers: {
        "xs": true,
        "top": true
      }
    }]
  }, [_c('v-col', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("Контактное лицо")])], 1)], 1), _vm._v(" "), _vm._l((_vm.contact), function(item, index) {
    return _c('v-row', {
      key: index
    }, [_c('v-col', {
      attrs: {
        "xs": "3",
        "sm": "6"
      }
    }, [_c('v-text', {
      attrs: {
        "danger": item[2]
      }
    }, [_vm._v("\n                            " + _vm._s(item[0]) + "\n                        ")])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "xs": "9",
        "sm": "6"
      }
    }, [_c('v-text', [_vm._v(_vm._s(item[1]))])], 1)], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "sm": "6"
    }
  }, [_c('v-row', {
    directives: [{
      name: "margin",
      rawName: "v-margin.xs.top",
      value: (3),
      expression: "3",
      modifiers: {
        "xs": true,
        "top": true
      }
    }]
  }, [_c('v-col', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "error": _vm.legalAddress[1]
    }
  }, [_vm._v("\n                            Юридический адрес\n                        ")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-text', [_vm._v(_vm._s(_vm.legalAddress[0]))])], 1)], 1), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "margin",
      rawName: "v-margin.xs.top",
      value: (3),
      expression: "3",
      modifiers: {
        "xs": true,
        "top": true
      }
    }]
  }, [_c('v-col', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling",
      "error": _vm.postalAddress[1]
    }
  }, [_vm._v("\n                            Почтовый адрес\n                        ")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12"
    }
  }, [_c('v-text', [_vm._v(_vm._s(_vm.postalAddress[0]))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.profile.isIdentified) ? _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('v-row', {
    attrs: {
      "align-items": "center"
    }
  }, [_c('v-col', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.right",
      modifiers: {
        "right": true
      }
    }]
  }, [_c('v-button', {
    attrs: {
      "flat": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'profileEdit',
          params: {
            edit: 'edit'
          }
        })
      }
    }
  }, [_vm._v("\n                    редактировать\n                ")])], 1)], 1)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8aa604c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/profile/ProfileInfo.vue
// module id = 931
// module chunks = 0